import React from 'react';
import PropTypes from 'prop-types';
import FreelancerPictures from './frelancer-pictures.svg';
import { Button } from '../../Button';
import './FreelancerChooserPopup.css';

export const FreelancerChooserPopup = ({ handleSelectYourExpert }) => (
  <div className="freelancer-chooser-popup">
    <div className="freelancer-chooser-popup__pictures">
      <img alt="freelancers" src={FreelancerPictures} />
    </div>
    <div className="freelancer-chooser-popup__title">
      These fully vetted top video creators have
      <br />
      been identified based on your selections.
    </div>
    <div className="freelancer-chooser-popup__description">
      You can either instant book them or invite them to your
      <br />
      project.
      <br />
      <br />
      <span className="freelancer-chooser-popup__description--bold">
        Instant Book
      </span>
      : With Instant Book your project is guaranteed
      <br />
      to get accepted and go to the editor of your choosing.
      <br />
      <br />
      <span className="freelancer-chooser-popup__description--bold">
        Request
      </span>
      : Invite up to 5 video creators and the 1st person to
      <br />
      accept will win!
    </div>
    <div className="freelancer-chooser-popup__action">
      <Button
        rounded
        onClick={handleSelectYourExpert}
        title="Select your expert"
        className="freelancer-chooser-popup__action--select-your-expert"
        textClassName="freelancer-chooser-popup__action--select-your-expert-text"
      />
    </div>
  </div>
);

FreelancerChooserPopup.propTypes = {
  handleSelectYourExpert: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Popup/FreelancerChooserPopup/FreelancerChooserPopup.js